import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.ShoppingCartBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.SHOP_CART_CONTROL) {
    throw new Error('Expected a valid Shopping Cart control')
  }

  return {
    type: next.BLOCK_TYPE.SHOPPING_CART,
    settings: {
      ...upCommonSettings(uischema),
      title: uischema.options?.cartTitle,
      footnote: uischema.options?.cartFootnote,
      price: {
        showComponents: uischema.options?.displayPriceComponents,
        showUnitaryAverage: uischema.options?.displayUnitaryAverage,
        showTrailingDecimalZeros: uischema.options?.showTrailingDecimalZeros
      },
      product: {
        expandedItemDetails: uischema.options?.forceExpandedItemDetails,
        enableProductDetails: uischema.options?.productDetailsModalEnabled
      },
      promotions: {
        enabled: uischema.options?.promoCodesEnabled
      }
    }
  }
}
